import React, { useState, useEffect } from 'react'
import { Calendar } from 'lucide-react'

const StickyMobileCTA: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      // Show CTA only after scrolling past the hero (approx 500px)
      setIsVisible(window.scrollY > 500)
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] transition-transform duration-300 ease-in-out md:hidden ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="mx-auto max-w-md">
        <a
          href="#agenda"
          className="flex w-full items-center justify-center gap-2 rounded-2xl border border-white/20 bg-accent px-6 py-4 font-bold text-white shadow-[0_12px_30px_-10px_rgba(2,132,199,0.55)] backdrop-blur-md hover:bg-accent-dark transition-colors"
        >
          <Calendar className="h-5 w-5" />
          Agendar Cita en SIMA
        </a>
      </div>
    </div>
  )
}

export default StickyMobileCTA
